import { css } from 'react-emotion'

const commonFillInput = {
  position: 'absolute',
  right: 0,
  bottom: 0,
  left: 0,
  height: '100%',
  width: '100%'
}

const styles = {
  component: css({
    position: 'relative',
    cursor: 'pointer'
  }),
  button: css({
    color: '#919191',
    padding: '8px 10px'
  }),
  slider: css({
    display: 'none',
    position: 'absolute',
    right: '5px',
    bottom: '100%',
    left: '5px',
    height: '56px',
    backgroundColor: '#ccc'
  }),
  track: css({
    position: 'absolute',
    top: '8px',
    bottom: '8px',
    left: '50%',
    width: '4px',
    transform: 'translateX(-50%)',
    backgroundColor: '#3e3e3e'
  }),
  fill: css({
    ...commonFillInput,
    backgroundColor: '#fff'
  }),
  input: css({
    ...commonFillInput,
    padding: 0,
    margin: 0,
    opacity: 0,
    '-webkit-appearance': 'slider-vertical',
    cursor: 'pointer'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Volume/VolumeStyles.js